/**
 * API Configuration
 * 
 * Provides environment-aware API base URLs.
 * Matches lore-native and lore-swift API configuration.
 * 
 * @module config/api
 */

/**
 * Get the API base URL based on the current environment
 * 
 * Routes all user API calls through the appcore-api gateway.
 * 
 * - Nonprod: https://appcore-api.lorehealthcare.io
 * - Prod: https://appcore-api.lore.co
 * 
 * @returns API base URL
 */
export function getApiBaseUrl(): string {
  return getAppcoreApiBaseUrl();
}

/**
 * Get the Appcore API base URL (e.g. nav-badges).
 *
 * - Nonprod: https://appcore-api.lorehealthcare.io
 * - Prod: https://appcore-api.lore.co
 */
export function getAppcoreApiBaseUrl(): string {
  const env = process.env.REACT_APP_ENV || 'development';
  if (process.env.REACT_APP_APPCORE_API_BASE_URL) {
    return process.env.REACT_APP_APPCORE_API_BASE_URL;
  }
  switch (env) {
    case 'production':
    case 'prod':
      return 'https://appcore-api.lore.co';
    case 'nonprod':
    case 'staging':
    case 'development':
    default:
      return 'https://appcore-api.lorehealthcare.io';
  }
}

